import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { ListGroup } from "../../Footer/StyledFooter";
import { StyledLinkList, StyledLinkListItem } from "@/components/List/LinkList/StyledLinkList";
import { colors } from "@/styles/utils/vars";
import { ButtonBase, cssButtonClean } from "@/ui/Button/StyledButton";
import { StyledPopoverDisclosure } from "@/ui/Popover/StyledPopover";
import { Heading3 } from "@/ui/Typography/Typography";
export const cssButtonRecall = "cssButtonRecall_cdr45kh";
export const StyledCallTitle = /*#__PURE__*/styled(Heading3)({
  name: "StyledCallTitle",
  class: "StyledCallTitle_s7ilui"
});
export const StyledCallContainer = /*#__PURE__*/styled('div')({
  name: "StyledCallContainer",
  class: "StyledCallContainer_so2nqaw"
});

require("./StyledCallInfo.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledCallInfo.tsx");